module.exports = __webpack_public_path__ + "img/result_ls_lens_down_angle.f817fd4d.jpg";